/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { LandingSummaryDto as FeatureLandingSummaryDto } from '../models/feature/landing-summary-dto';
import { getLandingSummary } from '../fn/landing/get-landing-summary';
import { GetLandingSummary$Params } from '../fn/landing/get-landing-summary';

@Injectable({ providedIn: 'root' })
export class LandingClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `landingGetLandingSummary()` */
  static readonly LandingGetLandingSummaryPath = '/landing/summary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLandingSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLandingSummary$Response(context?: HttpContext): Observable<StrictHttpResponse<FeatureLandingSummaryDto>> {
    const obs = getLandingSummary(this.http, this.rootUrl, {} satisfies GetLandingSummary$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLandingSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLandingSummary(context?: HttpContext): Observable<FeatureLandingSummaryDto> {
    const resp = this.getLandingSummary$Response(context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureLandingSummaryDto>): FeatureLandingSummaryDto => r.body)
    );
  }

}
